import {PageCollection} from '@simpli/resource-collection'
import {HttpExclude, Request} from '@simpli/serialized-request'
import {GithubOrganization} from '@/model/resource/GithubOrganization'

@HttpExclude()
export class GithubOrganizationCollection extends PageCollection<
  GithubOrganization
> {
  resource?: IGithubOrganizationCollectionResourcesHolder

  constructor() {
    super(GithubOrganization)
  }

  queryAsPage() {
    return this.listGithubOrganization()
  }

  async listGithubOrganization() {
    return await Request.get(`/client/github-organization`, {
      params: this.params,
    })
      .name('listGithubOrganization')
      .as(this)
      .getResponse()
  }
}

export interface IGithubOrganizationCollectionResourcesHolder {}
